import firebase from 'firebase/app';
export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c, r) => (c === 'x' ? (r = Math.random() * 16 | 0) : (r & 0x3 | 0x8)).toString(16));
}
export function isEmptyString(value) {
    return value == null || value.split(' ').join('').length === 0;
}
export function cloneObject(value) {
    return JSON.parse(JSON.stringify(value));
}
export function fixDate(date) {
    if (typeof date === 'string') {
        return new Date(date);
    }
    else if (date instanceof firebase.firestore.Timestamp) {
        return date.toDate();
    }
    return date;
}
export function randInt(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    if (max < min) {
        [max, min] = [min, max];
    }
    return min + Math.round(Math.random() * (max - min));
}
export function delay(value) {
    return new Promise(resolve => setTimeout(resolve, value));
}
export function debounce(fn, delayMs = 1000) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => fn(...args), delayMs);
    };
}
//# sourceMappingURL=index.js.map